import React from 'react';
import { Skeleton } from 'antd';

const SkeletonLoader: React.FC<{ active?: boolean, paragraph?: boolean, title?: boolean, style?: React.CSSProperties }> = ({
    active = true,
    paragraph = true,
    title = true,
    style
    }) => {
    return (
        <Skeleton active={active} paragraph={paragraph} title={title} style={style} />
    );
};

export default SkeletonLoader;
